import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TImportadorLugarDestinoViewModel, TImportadorViewModel } from '../datosbasicos/datosbasicos.types';
import { Observable } from 'rxjs';

@Injectable()
export class ImportadorLugarDestinoService {
    importadorEndpoint = this.baseUrl + 'api/importacion/importador/';
    lugarDestinoEndpoint = this.baseUrl + 'api/importacion/importadorlugardestino/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    /*Importador*/

    saveImportador(importador: TImportadorViewModel): Observable<any> {
        return this.http.post<TImportadorViewModel>(this.importadorEndpoint + 'SaveAsync', importador);
    }

    deleteRegistroSanitarioByIdSolicitudAsync(idSolicitud: number): Observable<any> {
        return this.http.put<TImportadorViewModel>(this.importadorEndpoint + 'DeleteRegistroSanitarioByIdSolicitudAsync', idSolicitud);
    }

    /*Lugar Destino*/

    saveImportadorLugarDestino(importadorLugarDestino: TImportadorLugarDestinoViewModel): Observable<any> {
        return this.http.post<TImportadorLugarDestinoViewModel>(this.lugarDestinoEndpoint + 'SaveAsync', importadorLugarDestino);
    }

    deleteRegistroSanitarioLugarDestinoByIdSolicitudAsync(idSolicitud: number): Observable<any> {
        return this.http.put<TImportadorLugarDestinoViewModel>(
            this.lugarDestinoEndpoint + 'DeleteRegistroSanitarioLugarDestinoByIdSolicitudAsync',
            idSolicitud,
        );
    }
}
